export const firebaseConfig = {
  apiKey: "AIzaSyAhUtwvvN3AqxjxxYclAY7NJFoByLcdvbI",
  authDomain: "team-somehow.firebaseapp.com",
  projectId: "team-somehow",
  storageBucket: "team-somehow.appspot.com",
  messagingSenderId: "792599913339",
  appId: "1:792599913339:web:f42c0360a4c5a15bea93de",
};
